export const InteractionsRulesConfigsKey = 'interactions-rules-configs';
export const InteractionTemplateKey = 'interaction-template';
export const InteractionsTrigerPointTypeKey = 'interactions-triger-point-type';
export const ActiveInteractionTemplateKey = 'active-interaction-template';
